import { render, staticRenderFns } from "./CampaignItem.vue?vue&type=template&id=7fe16c44&scoped=true&"
import script from "./CampaignItem.vue?vue&type=script&lang=js&"
export * from "./CampaignItem.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItem.vue?vue&type=style&index=0&id=7fe16c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe16c44",
  null
  
)

export default component.exports